<template>
  <div :class="{ 'mb-9': ((role == 'space_admin' || role == 'booster') && productPlan.attributes && productPlan.attributes.name == 'Pro Trial') || role == 'space_admin' && subscriptionEnds || (role == 'space_admin' && productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')) }">
    <SystemBarTopTrial v-if="(role == 'space_admin' || role == 'booster') && productPlan.attributes && productPlan.attributes.name == 'Pro Trial'"/>
    <SystemBarTopCancelSubscription v-if="role == 'space_admin' && subscriptionEnds"/>
    <SystemBarTopPaymentFailed v-if="role == 'space_admin' && productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')"/>
    <v-app-bar
      app
      clipped-right
      elevation="0"
      outlined
    > 
      <v-toolbar-title v-if="!mobile()">
        <v-img
          v-if="logo == null"
          data-testid="logo-space"
          src="../assets/rtplogo.svg"
          max-height="40"
          max-width="150"
          class="d-none d-sm-block mx-4 justify-center"
          contain
          position="top left"
        />
        <v-img
          v-else
          data-testid="logo-space"
          :src="logo"
          max-height="40"
          max-width="150"
          class="d-none d-sm-block mx-4 justify-center"
          contain
          position="top left"
        />
      </v-toolbar-title>
      <v-toolbar-title v-else>
        <v-img
          v-if="icon == null"
          data-testid="logo-space"
          src="../assets/rtpicon.png"
          max-height="40"
          max-width="40"
          class="mx-4 justify-center"
          contain
          position="top left"
        />
        <v-img
          v-else
          data-testid="logo-space"
          :src="icon"
          max-height="40"
          max-width="40"
          class="mx-4 justify-center"
          contain
          position="top left"
        />
      </v-toolbar-title>
      <v-divider vertical />
      <h3 class="pl-6">
        <v-clamp
          autoresize
          :max-lines="2"
        >
          {{ activitySurveyTitle }}
        </v-clamp>
      </h3>
      <v-spacer />
      <ContactUs v-if="(role == 'booster' || role == 'space_admin') && space!='id'" />
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            rounded
            elevation="0"
            exact
            v-on="on"
            @click="exitEditMode"
          >
            {{ $t('exit') }}
            <v-icon>mdi-logout</v-icon>
          </v-btn> 
        </template>
        <span>{{ $t('exitEditMode') }}</span>
      </v-tooltip>
    </v-app-bar>
    <ConfirmationDialog 
      v-if="dialogVisible"
      ref="confirmationDialog"
      :visible="dialogVisible"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      :cd-cancel-btn-color="cdCancelBtnColor"
      :cd-submit-btn-color="cdSubmitBtnColor"
      data-testid="confirmation-dialog"
      @input="clickOutside"
      @close="redirectToActivitySurvey"
      @proceedSubmit="saveSurvey"
    />
  </div>
</template>

<script>
import VClamp from 'vue-clamp';
import ContactUs from '../components/ContactUs';
import { getActivitySurvey } from '../api/activityApi';
import SystemBarTopTrial from '../components/SystemBarTopTrial';
import SystemBarTopCancelSubscription from '../components/SystemBarTopCancelSubscription'
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
import SystemBarTopPaymentFailed from '../components/SystemBarTopPaymentFailed'
import {eventBus} from '../eventbus'
import ConfirmationDialog from './ConfirmationDialog';
import i18n from '../plugins/i18n';

export default {
  components: {
      VClamp,
      ContactUs,
      SystemBarTopTrial,
      SystemBarTopCancelSubscription,
      SystemBarTopPaymentFailed,
      ConfirmationDialog
  },
  mixins: [repeatedMethodsMixin],
  data(){
      return{
          activitySurveyTitle: '',
          spaceId: window.$cookies.get('space_id'),
          surveyId:this.$route.params.surveyId,
          activityId: this.$route.params.id,
          space: window.location.host.split('.')[0],
          logo: localStorage.space ? JSON.parse(localStorage.space).logo : null,
          icon: localStorage.space ? JSON.parse(localStorage.space).icon : null,
          role: localStorage.space ? JSON.parse(localStorage.space).role : null,
          subscriptionEnds: localStorage.space? JSON.parse(localStorage.space).subscription_ends_at: '',
          dialogVisible: false,
          confirmationDialogTitle: '',
          confirmationDialogText: '',
          confirmationDialogCancelBtn: '',
          confirmationDialogSubmitBtn: '',
          cdSubmitBtnColor:'',
          cdCancelBtnColor:'',
          published: false,
          showDialogOnExit: false
      }
  },
  computed:{
    productPlan() {
        return this.$store.state.productPlan
    },
  },
  async created(){
      const response = await getActivitySurvey(this.surveyId)
      this.activitySurveyTitle = response.data.data.attributes.title
      this.published = response.data.data.attributes.published

      eventBus.$on('showDialogOnExit',(val)=>{
        this.showDialogOnExit = val
      })

  },
  beforeDestroy() {
    eventBus.$off('showDialogOnExit')
  },
  methods: {
    releaseEditor(){
      var payload = {'key1': this.surveyId, 'key2': this.activityId,'key3': 'survey' }
      this.$store.dispatch("releaseEditor", payload)
    },
    redirectToActivitySurvey(){
      eventBus.$emit('allowRedirect')
      this.dialogVisible=false
      if(this.productPlan.attributes && this.productPlan.attributes.name != 'Free'){
        this.releaseEditor();
      }
      this.$router.push({path: '/activity/' + this.$route.params.id + '/survey/' + this.$route.params.surveyId})
    },
    saveSurvey(){
      eventBus.$emit('saveSurvey')
    },
    clickOutside(){
      this.dialogVisible=false
      this.$router.push({path: '/activity/' + this.$route.params.id + '/survey/' + this.$route.params.surveyId + '/edit'})
    },
    exitEditMode(){
      if(this.showDialogOnExit){
        this.dialogVisible=true
        this.confirmationDialogTitle=i18n.t('confirmationDialogTitleExitActivityChecklistEdit')
        this.confirmationDialogText=i18n.t('confirmationDialogTextExitActivityChecklistEdit')
        this.cdSubmitBtnColor='accent'
        this.cdCancelBtnColor='darktext'
        this.confirmationDialogSubmitBtn= this.published ? i18n.t('publish') : i18n.t('saveAsDraft')
        this.confirmationDialogCancelBtn=i18n.t('doNotSaveBtn')
      }else{
        this.$router.push({path: '/activity/' + this.$route.params.id + '/survey/' + this.$route.params.surveyId})
      }
    }
  }
}
</script>

